export const GRAY_BLUE: string = '#496989';
export const TURQUOISE_DARK_GREEN: string = '#58A399';
export const OLIVE_GREEN: string = '#A8CD9F';
export const LIME_GREEEN: string = '#E2F4C5';
export const BASE_WHITE: string = '#FFFFFF';
export const BASE_RED: string = '#E83100';
export const BASE_WARNING_YELLOW: string = '#FFC300';
